import { Routes } from '@angular/router';
import { DashboardComponent } from './dashboard/dashboard.component';
import { UserComponent } from './user/user.component';
import { SignMessRequestsComponent } from './requests/sign-mess-requests.component';
import { TypographyComponent } from './typography/typography.component';
import { IconsComponent } from './icons/icons.component';
import { MapsComponent } from './maps/maps.component';
import { NotificationsComponent } from './notifications/notifications.component';
import { UpgradeComponent } from './upgrade/upgrade.component';
import { DmsControlComponent } from 'app/dms-control/dms-control.component';
import { DisplayComponent } from './display/display.component';
import { DisplaySectionComponent } from './display/display-section/display-section.component';
import { LoginComponent } from 'app/login/login.component';
import { DmslogComponent } from './dmslog/dmslog.component';
import { AuthGuard } from 'services/auth/auth-guard.service';
import { ActivityLogComponent } from './activity-log/activity-log.component';
import { WeightStationControlComponent } from './weight-station-control/weight-station-control.component';
import { UserListComponent } from './user-list/user-list.component';
import { AdminAuthGuard } from 'services/auth/admin-auth-guard.service';

export const AppRoutes: Routes = [
	{
		path: '',
		redirectTo: 'display',
		pathMatch: 'full'
	},
	{
		path: 'login',
		component: LoginComponent
	},
	{
		path: 'sso-login',
		component: LoginComponent
	},
	{
		path: 'dashboard',
		component: DashboardComponent,
		canActivate: [AuthGuard]
	},
	{
		path: 'profile',
		component: UserComponent,
		canActivate: [AuthGuard]
	},
	{
		path: 'requests',
		component: SignMessRequestsComponent,
		canActivate: [AuthGuard]
	},
	{
		path: 'activity',
		component: ActivityLogComponent,
		canActivate: [AuthGuard]
	},
	{
		path: 'typography',
		component: TypographyComponent,
		canActivate: [AuthGuard]
	},
	{
		path: 'icons',
		component: IconsComponent,
		canActivate: [AuthGuard]
	},
	{
		path: 'maps',
		component: MapsComponent,
		canActivate: [AuthGuard]
	},
	{
		path: 'notifications',
		component: NotificationsComponent,
		canActivate: [AuthGuard]
	},
	{
		path: 'control',
		component: DmsControlComponent,
		canActivate: [AuthGuard]
	},
	{
		path: 'weigh-station',
		component: WeightStationControlComponent,
		canActivate: [AuthGuard]
	},
	{
		path: 'display',
		component: DisplayComponent,
		children: [
			{
				path: ':signGroupName',
				component: DisplaySectionComponent
			}
		],
		canActivate: [AuthGuard]
	},
	{
		path: 'upgrade',
		component: UpgradeComponent,
		canActivate: [AuthGuard]
	},
	{
		path: 'log',
		component: DmslogComponent,
		canActivate: [AuthGuard]
	},
	{
		path: 'users',
		component: UserListComponent,
		canActivate: [AdminAuthGuard]
	}
];



// WEBPACK FOOTER //
// /Users/baselkilani/work/ODOT/projects/dmscontrol/DmsControl/src/app/app.routing.ts